import { useLayoutEffect, useState } from 'react'

// react-slick's infinite mode renders copies of the first and last slides
// into the track, each wrapped in a `.slick-slide.slick-cloned` element.
// Clones and originals have distinct React keys ("precloned…", "original…",
// "postcloned…"), so a mounted slide never changes between the two and the
// check only needs to run once. Starts as cloned so nothing live mounts
// before the DOM has been checked.
const useIsClonedSlide = ref => {
  const [cloned, setCloned] = useState(true)

  useLayoutEffect(() => {
    setCloned(Boolean(ref.current?.closest('.slick-cloned')))
  }, [ref])

  return cloned
}

export default useIsClonedSlide
